export const parseToArray = (stringData = "", delimiter = ",") => {
  const pattern = new RegExp(
    // Delimiters.
    "(\\" +
      delimiter +
      "|\\r?\\n|\\r|^)" +
      // Quoted fields.
      '(?:"([^"]*(?:""[^"]*)*)"|' +
      // Standard fields.
      '([^"\\' +
      delimiter +
      "\\r\\n]*))",
    "gi"
  );
  const items = [];
  let matches = null;

  while ((matches = pattern.exec(stringData))) {
    const matchedDelimiter = matches[1];
    const newRow = matchedDelimiter.length && matchedDelimiter !== delimiter;
    const matchedValue = matches[2]
      ? matches[2].replace(new RegExp('""', "g"), '"')
      : matches[3];

    if (!items.length || newRow) {
      items.push([matchedValue]);
    } else {
      items[items.length - 1].push(matchedValue);
    }
  }

  const lastItem = items[items.length - 1];

  if (lastItem.length === 1 && !lastItem[0]) {
    return items.slice(0, -1);
  }

  return items;
};
